import { jsx, jsxs } from 'react/jsx-runtime';
import { EGDSIcon } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSTriggerPill } from '../trigger-pill/index.esm.js';
import styles from '../../styles/uitk-egds-pill.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSPill = props => {
  const {
    active,
    altText,
    children,
    checked,
    className,
    disabled,
    icon,
    id,
    name,
    onChange,
    onClick,
    selected,
    triggerPill,
    toggleState,
    value,
    domRef
  } = props;
  const triggerPillProps = {
    active,
    children,
    className,
    disabled,
    icon,
    id,
    name,
    onClick,
    selected,
    toggleState,
    domRef
  };
  const baseClassName = 'uitk-pill';
  const wrapperClassName = getClassNameList(baseClassName, className, {
    [`${baseClassName}-disabled`]: disabled
  });
  const pillContentClassName = getClassNameList(`${baseClassName}-content`, {
    [`${baseClassName}-active`]: active,
    [`${baseClassName}-selected`]: selected
  });
  const inputValue = value ?? `${checked}`;
  return triggerPill ? jsx(EGDSTriggerPill, {
    ...triggerPillProps
  }) : jsxs("div", {
    className: wrapperClassName,
    children: [jsx("input", {
      id: id,
      name: name,
      checked: checked,
      type: "checkbox",
      onChange: onChange,
      className: getClassNameList(`${baseClassName}-standard is-visually-hidden`),
      disabled: disabled,
      value: inputValue
    }), jsxs("label", {
      className: pillContentClassName,
      htmlFor: id,
      "aria-label": altText,
      children: [icon && jsx(EGDSIcon, {
        className: getClassNameList(`${baseClassName}-icon`),
        name: icon
      }), jsx("span", {
        className: getClassNameList(`${baseClassName}-text`),
        children: children
      })]
    })]
  });
};
EGDSPill.defaultProps = {
  checked: false
};
EGDSPill.displayName = 'EGDSPill';
export { EGDSPill };